import React, { useCallback } from 'react';
import Modal from 'utils/packages/Modal';
import { Spacer, SettingsItem } from 'design-system';
import IconStatusUp from 'design-system/icons/IconStatusUp';
import { IconMoneyBag } from 'design-system/icons/IconMoneyBag';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import Text from 'design-system/Text';
import { selectTradingAccountHasPositions } from '../reducers/selectors';
import useInvestCashToTradingAccount from '../hooks/useInvestCashToTradingAccount';
import { blockInvestActionOnWeb } from '../webGate';
const strings = {
    investmentTitle: 'Investment',
    investmentDescription: 'Add money to your current investments or new ones',
    cashTitle: 'Cash',
    cashDescription: (aer) => aer ? (<Text TextThin-14 Gray>
        Add cash to earn{' '}
        <Text NumbersThin-14 Gray>
          {aer}%
        </Text>{' '}
        AER interest and invest when you’re ready
      </Text>) : ('Add cash to earn interest and invest when you’re ready'),
};
const SelectDepositToInvestmentAccountMethodModalContent = ({ amount, depositMethod, tradingAccount }) => {
    const navigation = useMainStackNavigation();
    const hasPositions = useAppSelector((store) => selectTradingAccountHasPositions(store, tradingAccount.id));
    const aer = tradingAccount.aer?.toFixed(2);
    const onInvestPress = useCallback(() => {
        Modal.hide(() => {
            if (hasPositions) {
                navigation.navigate('SelectAssetFromPositions', { tradingAccountId: tradingAccount.id, amount, depositMethod });
            }
            else {
                navigation.navigate('InvestDiscover', {
                    start: 'doItYourself',
                    depositAndBuyFlowParams: { tradingAccountId: tradingAccount.id, amount, depositMethod },
                });
            }
        });
    }, [amount, depositMethod, hasPositions, tradingAccount.id]);
    const investCashToTradingAccount = useInvestCashToTradingAccount(tradingAccount);
    const onCashPress = useCallback(() => {
        Modal.hide(() => {
            // Adding cash is a bank deposit, which is mobile-only
            if (blockInvestActionOnWeb('Add money'))
                return;
            if (amount && depositMethod) {
                investCashToTradingAccount({
                    amount,
                    depositMethod,
                });
            }
            else {
                navigation.navigate('AddMoneyToTradingAccount', { tradingAccountId: tradingAccount.id });
            }
        });
    }, [amount, depositMethod, investCashToTradingAccount, tradingAccount.id]);
    return (<>
      <Spacer h={8}/>
      <SettingsItem onPress={onInvestPress} title={strings.investmentTitle} icon={<IconStatusUp gradientKey="skyBlue"/>} description={strings.investmentDescription}/>
      <SettingsItem onPress={onCashPress} title={strings.cashTitle} description={strings.cashDescription(aer)} icon={<IconMoneyBag gradientKey="darkPurple"/>}/>
    </>);
};
export default SelectDepositToInvestmentAccountMethodModalContent;
